let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cvsXo")).then(() => parcelRequire('4kXYb'));